import React, { useEffect } from "react";
import { Form, Input } from "antd";

const { TextArea } = Input;

function TextBox({
  rows,
  textColor,
  controlHeight = 40,
  className = '',
  form,
  type,
  name,
  label,
  disabled,
  width,
  required,
  errorMessage,
  maxChar,
  maxCharErrorMessage,
  validateFunction,
  defaultValue,
  placeholder,
  readOnly,
  password,
  onChange,
  onFocus,
  onBlur,
  minHeight,
  id,
  labelCol,
  maxLength
}) {
  useEffect(() => {
    if (defaultValue) {
      form.setFieldsValue({ [name]: defaultValue });
    } else {
      form.setFieldsValue({ [name]: "" });
    }
  }, [])

  return (
    <Form.Item
      className={`${className} ${type === 'input' ? 'input' : 'textarea'}`}
      name={name}
      label={label}
      labelCol={{ span: labelCol ? labelCol : 8 }}
      wrapperCol={!label ? { span: 24 } : undefined}
      style={{ width: width, fontWeight: 600 }}
      rules={[
        {
          required: required,
          message: errorMessage,
        },
        // {
        //   max: maxChar ? maxChar : 200,
        //   message: maxCharErrorMessage
        //     ? maxCharErrorMessage
        //     : "Error Mx Char 200",
        // },
        // () => ({
        //   validator(rule, value) {
        //     return validateFunction
        //       ? validateFunction(rule, value)
        //       : Promise.resolve();
        //   },
        // }),
      ]}
    >
      {type === "input" ? (
        <>
          {password ? (
            <Input.Password
              id={"inputterReport"}
              type={"text"}
              disabled={disabled ? disabled : false}
              autoComplete="off"
              // defaultValue={defaultValue ? defaultValue : null}
              placeholder={placeholder}
              readOnly={readOnly ? readOnly : false}
              style={{ fontWeight: 600, height: 40 }}
              onChange={onChange ? onChange : () => { }}
            />
          ) : (
            <Input
              onFocus={onFocus}
              onBlur={onBlur}
              id={id ? id : undefined}
              type={"text"}
              disabled={disabled ? disabled : false}
              autoComplete="off"
              //  defaultValue={defaultValue ? defaultValue : null}
              placeholder={placeholder}
              readOnly={readOnly ? readOnly : false}
              style={{ fontWeight: 600, height: controlHeight, color: textColor, textAlign: textColor ? 'center' : undefined }}
              maxLength={maxLength}
            // onChange={(e) => {
            //   form.setFieldsValue({ [name]: e.target.value });
            // }}
            />
          )}
        </>
      ) : (
        <TextArea
          rows={rows}
          disabled={disabled}
          style={{ fontWeight: 600, minHeight: controlHeight || 40, width: '100%', minWidth: '100%' }}
          defaultValue={defaultValue}
          placeholder={placeholder}
        />
      )}
    </Form.Item>
  );
}

export default TextBox;
